<template>
    <div class="card">
        <v-lazy>

            <div class="image">
                <img width="416" height="234" :src="video.thumbnail" :alt="video.title" class="hit-image" />
            </div>
        </v-lazy>
        <div class="user">

            <img class="avatar" width="40" height="40" :src="video.author.avatar">
            <div class="b-info">
                <div class="e-title">{{ video.title }}</div>
                <div class="e-date pt-1">
                    {{ video.views |
                        formatEngagementMetric }} views • {{ video.likes | formatEngagementMetric }} likes • {{
        video.duration
    }}
                    min watch time</div>

            </div>
        </div>

    </div>
</template>

<style scoped>
.card {
    --primary: black;
    --secondary: #0DD7B5;
    --dark-green: #1A7D6D;
    --blue-500: #00a3fe;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);


    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;

    padding: 0;
    height: auto;
    background-color: whitesmoke;

    border-radius: 0.5rem;

}

.card .rectangle {
    position: absolute;

    width: 0.925rem;
    aspect-ratio: 1 / 1;
    background-color: white;
    opacity: 0;
    box-shadow: 0rem 0rem 0rem 0.175rem black;
}



.card .image {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: auto;

    /* border-radius: 0.25rem; */
}

.card .image .svg {
    width: 2.5rem;
    fill: black;
}

.card .title {
    position: relative;


    font-size: 1.25rem;
    color: white;
    font-weight: bold;
}

.card .love {
    padding-left: 12px;
    display: flex;
    align-items: center;
    gap: 0.375rem;

    font-size: 1rem;
    font-weight: bold;
    color: black;
}

.card .meta {
    display: flex;
    flex-direction: row;
    gap: 0px;
}

.card .user {
    background: #f7f8f9;
    border-radius: 9px;
    height: 100px;
    padding: 9px 12px;
    text-align: left;
    display: flex;
}

@media only screen and (max-width: 767px) {
    .card .user {
        height: 80px;
    }
}

.card .avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1px solid whitesmoke;
    margin-right: 12px;
}

.card .b-info {
    flex: 1;
}

.card .e-title {
    font-size: 14px;
    font-weight: 700;
}

.card .e-date {
    font-size: 13px;
    color: grey;
}


.card .title {
    padding-left: 12px;
    padding-right: 12px;
    display: flex;
    align-items: center;
    gap: 0.375rem;

    font-size: 1rem;
    font-weight: bold;
    color: black;
}

.card .description {
    padding-left: 12px;
    padding-right: 12px;
    display: flex;
    align-items: center;
    gap: 0.375rem;

    font-size: 0.8rem;
    font-weight: normal;
    color: black;
}

.card .love .svg {
    width: 1.25rem;
    fill: red;
}

.card .category {
    padding-left: 12px;
    display: flex;
    align-items: center;
    gap: 0.375rem;
}

.card .category .button {

    /* padding-left: 12px; */
    padding: 0.25rem 0.5rem;
    background-color: #d2dcd5;

    font-size: 0.7rem;
    color: black;

    border: 2px solid transparent;
    border-radius: 9999px;
    transition: all 0.3s ease-in-out;
}

.card .action {
    padding-block: 0.375rem;
    margin-top: 0.75rem;
    background-color: var(--secondary);

    font-size: 0.75rem;
    font-weight: 700;
    color: black;

    border: 2px solid transparent;
    border-radius: 4px;
    transition: all 0.3s ease-in-out;
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 12px;
}

.card .action:hover {
    cursor: pointer;
    background-color: black;
    color: white;
}
</style>

<script>
export default {

    components: {
    },
    filters: {
        relativePublicationDate: function (date) {
            return moment(date).fromNow();
        },
        formatEngagementMetric: function (likes) {

            if (isNaN(likes)) {
                return 0;
            }

            let formatted = Math.abs(likes) > 999 ? Math.sign(likes) * ((Math.abs(likes) / 1000).toFixed(1)) + 'k' : Math.sign(likes) * Math.abs(likes)
            return formatted;
        }
    },
    props: ['video'],
    data() {
        return {
        };
    },
    created() {

    },
    computed: {

    },
    methods: {

    }
};
</script>